import { render, staticRenderFns } from "./SlideText.vue?vue&type=template&id=3f4dd92d&scoped=true&"
import script from "./SlideText.vue?vue&type=script&lang=ts&"
export * from "./SlideText.vue?vue&type=script&lang=ts&"
import style0 from "./SlideText.vue?vue&type=style&index=0&id=3f4dd92d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4dd92d",
  null
  
)

export default component.exports